import { Field, FieldError } from "@/components/ui";
import { DatePicker } from "@/components/ui/DatePicker";
import { toISODateOnly } from "@/lib/time";
import type {
  ControllerFieldState,
  ControllerRenderProps,
} from "react-hook-form";
import type { AOEQuestion } from "../../../network/useRetrieveAOEForOrder";
import type { AOEFormSchema } from "../schemas";

export const DateQuestion = ({
  question,
  field,
  fieldState,
  disabled,
}: {
  question: AOEQuestion;
  field: ControllerRenderProps<
    AOEFormSchema,
    `questionnaires.${string}.${string}`
  >;
  fieldState: ControllerFieldState;
  disabled: boolean;
}) => {
  const adjustedDate = field.value
    ? new Date(`${field.value as string}T00:00:00`)
    : undefined;

  return (
    <Field data-invalid={fieldState.invalid}>
      <DatePicker
        label={`${question.required ? "*" : ""}${question.question}`}
        {...field}
        setDate={(date) => {
          field.onChange(toISODateOnly(date));
        }}
        date={adjustedDate}
        closeOnSelect
        disabled={disabled}
        aria-invalid={fieldState.invalid}
      />
      <FieldError errors={[fieldState.error]} />
    </Field>
  );
};
